import { Link, useNavigate } from "react-router-dom";
import { Button, FormControl, Typography, Box } from "@mui/material";
import theme from "../../theme";
import InputField from "../common-components/InputField";
import { useFormik } from "formik";
import { forgotPasswordSchema } from "../../form-schema";
import CustomButton from "../common-components/CustomButton";
import { useAppDispatch } from "../../stores/store";
import { forgotPassword } from "../../stores/auth";
import { ForgotPassPayload } from "../../stores/auth/Interface";
import { EmailIcon } from "../../assets/Icon/singUpIcon";
import Toast from "../common-components/Toast";
import { useEffect, useState } from "react";
import { setToast } from "../../stores/toast/toastslice";

const ForgetForm = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [emailMessage, setEmailMessage] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  // regex to detect email inside text
  const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;

  const handleForget = async (values: ForgotPassPayload) => {
    setLoading(true);
    try {
      const response = await dispatch<any>(forgotPassword(values)).unwrap();

      if (response?.data?.status === 1) {
        localStorage.setItem("email", response.data.email);

        dispatch<any>(
          setToast({
            message: response.data.message,
            type: "success",
            title: "Success",
          })
        ); // ✅ Global toast

        setLoading(false);
        setTimeout(() => {
          navigate("/otp-verify");
        }, 500);
      } else {
        const message = response?.data?.message;
        setLoading(false);
        if (message?.match(emailRegex)?.[0]) {
          setEmail(message?.match(emailRegex)?.[0]);
          setEmailMessage(message);
          return;
        }
        dispatch<any>(
          setToast({
            message: response.data.message,
            type: "error",
            title: "Error",
          })
        ); // ✅ Global toast
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: forgotPasswordSchema,
    onSubmit: handleForget,
  });
  return (
    <>
      <Box className="form-container">
        <Box>
          <Typography
            variant="h1"
            className="logo-title"
            style={{ color: "#05000B", marginBottom: "20px" }}
          >
            Forgot password
          </Typography>
          <Typography
            variant="h3"
            className="logo-title1"
            style={{ color: "#6C6F71" }}
          >
            Please enter your email address and we will send you a one-time
            password(OTP).
          </Typography>
          {email?.length > 0 && (
            <Box
              sx={{
                textAlign: "start",
                width: 600,
                marginTop: 1,
                lineHeight: "24px",
              }}
            >
              <a
                href={`mailto:${email}`}
                style={{
                  color: "red",
                  fontSize: "16px",
                  textAlign: "start",
                  textDecoration: "none",
                  cursor: "pointer",
                  fontWeight: 400,
                }}
              >
                {emailMessage?.replace(`${email}.`, "")}
                <span
                  style={{
                    color: "red",
                    textDecoration: "underline",
                  }}
                >
                  {email}
                </span>
              </a>
            </Box>
          )}
        </Box>
        <form onSubmit={formik.handleSubmit}>
          <FormControl
            variant="standard"
            sx={{ width: "100%", paddingTop: "30px" }}
          >
            <>
              <Typography
                sx={{ color: theme.palette.myCustomColor.dark }}
                variant="h4"
              >
                Email Address
              </Typography>
              <InputField
                formik={formik}
                margin="normal"
                placeholder={"Enter email address"}
                type="text"
                name="email"
                icon={<EmailIcon />}
                minWidth="389px"
              />
            </>
            <CustomButton
              btnTitle={"Send"}
              maxwidth="450px"
              type="submit"
              loading={loading}
            />
            <Typography
              variant="h4"
              style={{
                color: theme.palette.myCustomColor.link,
                marginTop: "15px",
                marginBottom: "30px",
              }}
            >
              <Link
                to="/login"
                style={{
                  textDecoration: "none",
                  color: theme.palette.myCustomColor.link,
                }}
              >
                Back to Login
              </Link>
            </Typography>
          </FormControl>
        </form>
      </Box>
    </>
  );
};

export default ForgetForm;
